var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79647 0.0974304C7.01882 0.261185 7.06632 0.574185 6.90256 0.79653C6.77536 0.969235 6.64814 1.1334 6.53655 1.2764C6.3138 1.5618 6.00713 1.9441 5.67396 2.3278C5.34294 2.70905 4.97592 3.1032 4.63328 3.40595C4.46255 3.5568 4.28605 3.69555 4.11395 3.7993C3.9556 3.89475 3.738 4 3.49995 4C3.2619 4 3.04425 3.89475 2.8859 3.7993C2.7138 3.69555 2.53735 3.5568 2.3666 3.40595C2.02395 3.1032 1.65695 2.70905 1.3259 2.3278C0.99275 1.9441 0.686099 1.5618 0.463299 1.2764C0.351749 1.1334 0.224499 0.969235 0.0972991 0.796535C-0.0664511 0.574185 -0.018951 0.261185 0.203399 0.0974301C0.292799 0.0316001 0.3968 -8.53497e-05 0.499899 4.6548e-06L3.49995 1.75629e-08L6.49996 1.48698e-07C6.60306 -8.48468e-05 6.70709 0.0316004 6.79647 0.0974304Z",
    fill: "#212129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.f5f4195d35fcc1eeee01cf1d0768ba1f.svg";
export { ForwardRef as ReactComponent };